import { Grid, Paper } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import PlanHeader from "../../../shared/enrollment/planCode/PlanHeader";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import EditIcon from "@mui/icons-material/Edit";
import { useCallback, useContext } from "react";
import { ThemeContext } from "../../../../contexts";
import { AcknowledgementProps } from "../../../../types/components/enrollmentProps.types";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import PanToolIcon from "@mui/icons-material/PanTool";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import ClearIcon from "@mui/icons-material/Clear";
import "./enrollmentAcknowledgement.css";
import { Status } from "../../../../types/enrollment.types";
import downloadFile from "../../../../utils/commonFunctions/downloadFile";
import downloadFileNew from "../../../../utils/commonFunctions/downloadFileNew";

type StatusIcon = {
	[key in Status]: JSX.Element;
};

type StatusMessage = {
	[key in Status]: string;
};

const statusIcon: StatusIcon = {
	ACTIVE: <DoneAllIcon className="thank-icon" />,
	SUBMITTED: <DoneOutlineIcon className="thank-icon" />,
	REJECTED: <ClearIcon className="thank-icon" />,
	WAIVED: <PanToolIcon className="thank-icon" />,
	"WAIVED - WAITING FOR APPROVAL": <WatchLaterIcon className="thank-icon" />,
	OPENED: <></>,
	CLOSED: <></>
};

const statusMessage: StatusMessage = {
	ACTIVE: "Your enrollment is successfully Activated",
	SUBMITTED: "Your enrollment has been successfully Submitted",
	REJECTED: "Your enrollment has been Rejected",
	WAIVED: "Your enrollment is successfully waived",
	"WAIVED - WAITING FOR APPROVAL": "Your enrollment for waived is pending for approval",
	OPENED: "",
	CLOSED: ""
};

const EnrollmentAcknowledgement = ({
	idCardAccessPointRequired,
	dependentChangePointRequired,
	carrierPhoneNo,
	carrierWebsite,
	planDocument,
	planName,
	addDependentLink,
	removeDependentLink,
	planCode,
	status,
	customStatusMeesage
}: AcknowledgementProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);
	// console.log("status", status);
	const handleDownloadPlanDocument = useCallback(() => {
		if (!planDocument) {
			alert("No plan document is available");
			return;
		} else downloadFileNew(planDocument);
	}, [planDocument]);

	return (
		<div className="enrollment-acknowledgement">
			<PlanHeader planCode={planCode} planName={planName} />
			<div className="theme-plan-section-margin" />
			{!["OPENED", "CLOSED"].includes(status) ? (
				<>
					<Grid container direction="column" alignItems="center">
						{statusIcon[status as keyof StatusIcon]}
					</Grid>
					<div className="thank-note">
						{customStatusMeesage && status === "SUBMITTED"
							? customStatusMeesage
							: statusMessage[status as keyof StatusMessage]}
					</div>
				</>
			) : null}
			<div className="theme-plan-section-margin" />
			<div className="theme-plan-icon-item-container">
				<div>
					<EditIcon className="event-icon" style={{ color: theme.primary_color }} />
				</div>
				<div className="theme-plan-point-text">
					<span>If you want to download the Plan Document, </span>
					<span
						style={{ color: theme.primary_color, cursor: "pointer", fontWeight: "800" }}
						onClick={handleDownloadPlanDocument}
					>
						Click Here
					</span>
				</div>
			</div>
			{idCardAccessPointRequired ? (
				<>
					<div className="theme-plan-icon-item-container">
						<div>
							<EditIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-point-text">
							If you want to access the Temp ID card, Please click on `&quot;`Generate ID Card`&quot;`
							button from your home page.
						</div>
					</div>
				</>
			) : null}
			{dependentChangePointRequired ? (
				<>
					<div className="theme-plan-icon-item-container">
						<div>
							<EditIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-point-text">
							If you want to make any changes for your dependent, please follow the below details -
						</div>
					</div>

					<div className="theme-plan-icon-item-container" style={{ marginLeft: "30px" }}>
						<div>
							<ControlPointIcon className="sub-event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-subpoint-text">
							If you want to add a new dependent,{" "}
							<a style={{ color: theme.primary_color }} href={addDependentLink}>
								Click Here
							</a>{" "}
							(Remeber, if you want to add a dependent due to a special event e.g. Marrige, Birth of a
							Child, you need to provide a document related to that event/s)
						</div>
					</div>
					{/* <div className="theme-plan-icon-item-container" style={{ marginLeft: "30px" }}>
						<div>
							<ControlPointIcon className="sub-event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-subpoint-text">
							If you want to remove a dependent from the existing benefit,{" "}
							<a style={{ color: theme.primary_color }} href={removeDependentLink}>
								Click Here
							</a>{" "}
							(Remeber, if you want to remove a dependent due to any special event, you need to provide a
							document related to that event/s)
						</div>
					</div> */}
				</>
			) : null}
			<div className="theme-plan-section-margin" />
			<div className="theme-plan-icon-item-container">
				<div>
					<LinkIcon className="link-icon" />
				</div>
				<div className="link-text">
					For more details related to plan, please contact{" "}
					<span style={{ color: theme.primary_color, fontWeight: "800" }}>{carrierPhoneNo}</span> or visit the
					website{" "}
					<a
						style={{ color: theme.primary_color }}
						href={`https://${carrierWebsite}`}
						target="_blank"
						rel="noopener noreferrer"
					>
						{carrierWebsite}
					</a>
				</div>
			</div>
		</div>
	);
};

export default EnrollmentAcknowledgement;
